<h2>{{ 'integrations.mailchimp.mailchimp-sync.component.title' | translate | titlecase }}</h2>

<div class="container-fluid">
  <p [hidden]="!loading">
    <wl-busy [show]="loading"></wl-busy>
    {{ 'common.loading' | translate | titlecase }}...
  </p>
  <div class="alert alert-danger" [hidden]="!loadError">
    {{ loadError }}
  </div>
  <div class="row">
    <div class="col-sm-12">
      <ul class="list-unstyled">
        <li>
          <label>
            <input type="radio" [(ngModel)]="syncModel.SyncMode" [value]="syncModeOptions.Full" name="radiogroup" />
            {{ 'integrations.mailchimp.mailchimp-sync.component.full-sync' | translate }}
          </label>
        </li>
        <li>
          <label>
            <input type="radio" [(ngModel)]="syncModel.SyncMode" [value]="syncModeOptions.Manual" name="radiogroup" />
            {{ 'integrations.mailchimp.mailchimp-sync.component.manual-sync' | translate }}
          </label>
          <ul class="list-unstyled simple-indent" [hidden]="syncModel.SyncMode != syncModeOptions.Manual">
            <li>
              <div class="container-fluid marginalize">
                <wl-profile-search-modal
                  #profileSearch
                  [advancedSearchVisible]="true"
                  [alwaysShowAdvancedSearch]="true"
                  [showRelatedProfile]="false"
                  [showMembershipLevel]="false"
                  [showEmailType]="true"
                  (close)="profilesSearched($event)"
                ></wl-profile-search-modal>
                <button app-add-button
                  class="atlas-btn atlas-btn-secondary"
                  name="mailchimp-sync-component_select-profiles"
                  [label]="'integrations.mailchimp.mailchimp-sync.component.select-profiles' | translate | titlecase"
                  (click)="selectProfiles()"
                >
                </button>
              </div>
            </li>
            <li>
              <div class="container-fluid marginalize">
                <p-table [showGridlines]="true"
                  #profilesToSyncGrid
                  [rows]="10"
                  [value]="profiles"
                  [paginator]="true"
                  [totalRecords]="profiles.length"
                  [sortField]="'ReportName'"
                >
                  <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
                    <SortAltIcon *ngIf="sortOrder === 0">
                      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
                    </SortAltIcon>
                    <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
                      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
                    </SortAmountUpAltIcon>
                    <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
                      <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
                    </SortAmountDownIcon>
                  </ng-template>
                  <ng-template pTemplate="header">
                    <tr>
                      <th [pSortableColumn]="'ProfileId'" class="text-center" style="width: 120px">
                        {{ 'common.personal-information.profile-id' | translate | titlecase }}
                        <p-sortIcon></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'ReportName'">
                        {{ 'common.personal-information.profile-name' | translate | titlecase }}
                        <p-sortIcon></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'Email'">
                        {{ 'common.personal-information.email-address' | translate | titlecase }}
                        <p-sortIcon></p-sortIcon>
                      </th>
                      <th [pSortableColumn]="'EmailType'">
                        {{ 'profiles.search.email-type' | translate | titlecase }}
                        <p-sortIcon></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-item>
                    <tr>
                      <td class="text-center">{{ item.ProfileId }}</td>
                      <td>
                        <wl-profile-type-icon
                          *ngIf="item && item.ProfileId"
                          [isMember]="item.Member"
                          [isOrg]="item.OrgInd"
                          [profileId]="item.ProfileId"
                          [memberTypeIconColor]="item.MemberTypeIconColor"
                        ></wl-profile-type-icon>
                        {{ item.ReportName }}
                      </td>
                      <td>{{ item.Email }}</td>
                      <td>{{ item.EmailType }}</td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr>
                      <td colspan="4" class="text-center">
                        {{ 'common.phrases.no-results-found' | translate | titlecase }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <p-progressSpinner *ngIf="loading"></p-progressSpinner>
              </div>
            </li>
            <li>
              <div class="container-fluid marginalize">
                <label>
                  {{ 'integrations.mailchimp.mailchimp-sync.component.select-list' | translate }}:<br />
                  <select class="dropdown form-control-like" [(ngModel)]="syncModel.ListId" name="mailchimp-sync-component_select-list">
                    <option [value]="'new'">
                      {{ 'integrations.mailchimp.mailchimp-sync.component.create-new-list' | translate | titlecase }}
                    </option>
                    <option [value]="list.ID" *ngFor="let list of mailChimpLists">{{ list.Name }}</option>
                  </select>
                </label>
              </div>
            </li>
            <li [hidden]="syncModel.ListId == '' || syncModel.ListId != 'new'">
              <div class="container-fluid marginalize">
                <label>
                  {{ 'integrations.mailchimp.mailchimp-sync.component.list-name' | translate | titlecase }}:<br />
                  <input
                    type="text"
                    class="form-control"
                    #listNameField="ngModel"
                    [(ngModel)]="syncModel.ListName"
                    placeholder="{{ 'integrations.mailchimp.mailchimp-sync.component.enter-list-name' | translate }}"
                    [required]="syncModel.ListId == 'new'"
                    name="mailchimp-sync-component_list-name"
                  />
                </label>
                <div class="text-danger" [hidden]="!listNameField.errors?.required">{{ 'common.required' | translate | titlecase }}</div>
              </div>
            </li>
            <li [hidden]="syncModel.ListId == 'new'">
              <div class="container-fluid marginalize">
                <label>
                  <input
                    type="checkbox"
                    [(ngModel)]="syncModel.UnsubscribeExistingMembers"
                    name="mailchimp-sync-component_unsubscribe-existing-members"
                  />
                  {{ 'integrations.mailchimp.mailchimp-sync.component.unsubscribe' | translate }}
                </label>
              </div>
            </li>
          </ul>
        </li>
        <li>
          <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="syncProfiles()">
            {{ 'integrations.mailchimp.mailchimp-sync.component.sync-profiles' | translate | titlecase }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>
